import getProduct from '~/src/lib/v2/product/getProduct';
import getEntityField from '~/src/lib/getEntityField';

const getProductName = (business, product, lang) => {
    let txt = '';

    txt = getEntityField(product, 'name');

    //https://trello.com/c/6iJ2urXn/2413-probl%C3%A8me-daffichage-des-produits-en-front-dans-le-cas-o%C3%B9-on-ajoute-une-garniture
    /*
  if (product.garnishs) {
    product.garnishs.map((garnishId, index) => {
      const garnish = getProduct(business.products, "id", garnishId);
      if (garnish) {

        txt = getEntityField(garnish, 'name')

      }
    });
  }
  */
    return txt;
};

export default getProductName;
